import BaseService from "./BaseService";

export default class ChamadoService extends BaseService {

  constructor(self) {
    super(self);
  }

  ObterChamadosDoAluno(parameters) {
    return this.ExecutaFetch("/api/Chamado/ObterChamadosDoAluno", "POST", parameters);
  }
}